import { render, staticRenderFns } from "./deptPower.vue?vue&type=template&id=2a064042&scoped=true&"
import script from "./deptPower.vue?vue&type=script&lang=js&"
export * from "./deptPower.vue?vue&type=script&lang=js&"
import style0 from "./deptPower.vue?vue&type=style&index=0&id=2a064042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a064042",
  null
  
)

export default component.exports